import * as z from 'zod';
import { SERVICE_PLAN_ITEMS_METRICS } from 'src/features/servicePlanItems/utils/types';

export type ServicePlanItemFormSchemaValues = z.infer<typeof servicePlanItemFormSchema>;
export const servicePlanItemFormSchema = z.object({
    name: z.string().nonempty(),
    code: z.string().nonempty(),
    is_required: z.boolean(),
    metric: z.enum(SERVICE_PLAN_ITEMS_METRICS).optional().nullable(),
    external_item_id: z.int().optional().nullable(),
    service_plan: z.string().nonempty(),
    starting_quantity: z.int().optional().nullable(),
});
